import { Grid } from "@material-ui/core"
import { SelectIcon } from "App/Assets"
import {
  InputTextMaster,
  InputOptionMaster,
  MasterButton,
  InputAsyncOptionMaster,
} from "App/Component/ui"
import { fetchDataPost, isNull } from "App/utils/helpers"
import React, { useEffect, useState } from "react"
import { TYPE_INSTANCE1, TYPE_INSTANCEVCLAIM } from "App/constants"
import { useMultipleSelect } from "hooks"
import { useDokterSEP, useKelasRawat } from "./hooks"
import { LIST_URL_MASTER } from "utils/masters"
import { validasiMultipleSelect } from "hooks/useMultipleSelect"

import { PilihFlagProcedure } from "./SelectOption/PilihFlagProcedure"
import { PilihKodePenunjang } from "./SelectOption/PilihKodePenunjang"
import { getDataBridge } from "App/Component/layout/Manajemen/Dokter/utils"
import {
  pembiayaanDanPenanggungJawab,
  PILIH_ASSESMENT_PELAYANAN_SELAIN_NORMAL,
  PILIH_TUJUAN_KUNJUNGAN,
  TUJUAN_KUNJUNGAN_NORMAL,
  TUJUAN_KUNJUNGAN_PROSEDUR,
} from "./constants"

export const FormSEPManual = ({
  formData,
  setFormData,
  type,
  handleChange,
  handleClickNoKontrol,
  handleClickNoRujukan,
}) => {
  // const { kodeFaskes, loadingFaskes } = useFaskes(formData.ppk_rujukan_search);
  const kelasRawat = useKelasRawat()
  const dokter = useDokterSEP()
  const multipleSelectData = useMultipleSelect([
    {
      url: LIST_URL_MASTER.spesialis.list,
      search: true,
      type_instance: TYPE_INSTANCE1,
      value: "codebridgepolibpjs",
      label: ["name"],
      type_response: "body",
      key: "spesialis",
    },
  ])

  const preLoadDataFaskes = async (inputValue) => {
    if (inputValue.length >= 3) {
      const res = await fetchDataPost(
        TYPE_INSTANCEVCLAIM,
        "api/v1/emr/bridging/referensi/faskes",
        "response",
        {
          kode_faskes: isNull(inputValue) ? "" : inputValue,
          jenis_faskes: formData.asal_rujukan,
        },
        {},
        "faskes",
      )

      if (res) {
        const data = []
        res.map((item) => {
          return data.push({
            value: item["kode"],
            label: item[("kode", "nama")],
          })
        })

        return data
      } else {
        return []
      }
    } else {
      return []
    }
  }
  const preLoadDataPoliklinik = async (inputValue) => {
    if (inputValue.length >= 3) {
      const res = await fetchDataPost(
        TYPE_INSTANCEVCLAIM,
        "api/v1/emr/bridging/referensi/poli",
        "response",
        {
          poli: isNull(inputValue) ? "" : inputValue,
        },
        {},
        "poli",
      )

      if (res) {
        const data = []
        res.map((item) => {
          return data.push({
            value: item["kode"],
            label: item[("kode", "nama")],
          })
        })

        return data
      } else {
        return []
      }
    } else {
      return []
    }
  }

  const [rows, setRows] = useState([])

  const setNewData = async () => {
    const response = await getDataBridge()
    const _temp = []
    if (response.state) {
      response.data.map((item) => {
        _temp.push({
          value: item.kodedokter,
          label: item.namadokter,
        })
      })

      setRows(_temp)
    } else {
      setRows([])
    }
  }

  useEffect(() => {
    setNewData()
  }, [])

  if (type === "MANUAL") {
    return (
      <>

       
        <Grid item sm={4}>
          <InputAsyncOptionMaster
            label="PPK RUJUKAN"
            name="ppk_rujukan_name"
            id="ppk_rujukan_name"
            needParse={false}
            withSearch={true}
            data={[]}
            error
            message="Masukkan minimal 3 karakter"
            loadOptions={preLoadDataFaskes}
            defaultData={formData.ppk_rujukan_kode}
            value={formData.ppk_rujukan_kode}
            labelValue={formData.ppk_rujukan_name}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  ppk_rujukan_kode: "",
                  ppk_rujukan_name: "",
                })
              } else {
                setFormData({
                  ...formData,
                  ppk_rujukan_kode: e.value,
                  ppk_rujukan_name: e.label,
                })
              }
            }}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='tgl_rujukan'
            label='TGL RUJUKAN'
            id='tgl_rujukan'
            type='date'
            required={true}
            value={formData.tgl_rujukan}
            onChange={handleChange("tgl_rujukan")}
            placeholder=''
          />
        </Grid>
        <Grid item sm={4}>
          {formData.is_bayi ? (
            <>
              <InputTextMaster
                name="no_rujukan"
                label="NO RUJUKAN (SEP ASAL IBU)"
                id="no_rujukan"
                placeholder="No Rujukan"
                value={formData.no_rujukan}
                onChange={handleChange("no_rujukan")}
              />
            </>
          ) : (
            <div
              style={{
                display: "flex",
              }}
            >
              <InputTextMaster
                name="no_rujukan"
                label="NO RUJUKAN"
                id="no_rujukan"
                placeholder="No Rujukan"
                value={formData.no_rujukan}
                onChange={handleChange("no_rujukan")}
              />

              <MasterButton
                type={"button"}
                color="lightgreen"
                name=""
                size="sm"
                withIcon={true}
                onClick={handleClickNoRujukan}
                style={{
                  marginTop: "1.5rem",
                  width: "32px",
                  height: "32px",
                }}
                icon={
                  <SelectIcon
                    width="16px"
                    height="16px"
                    style={{
                      marginLeft: "-0.5rem",
                    }}
                  />
                }
              />
            </div>
          )}
        </Grid>
        <Grid item sm={4}>
          <InputOptionMaster
            name="kode_dpjp"
            label="DPJP"
            id="kode_dpjp"
            withSearch={true}
            needParse={false}
            value={formData.kode_dpjp}
            labelValue={formData.kode_dpjp_dokter}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  kode_dpjp: null,
                  kode_dpjp_dokter: "Pilih DPJP",
                })
              } else {
                setFormData({
                  ...formData,
                  kode_dpjp: e?.value,
                  kode_dpjp_dokter: e?.label,
                })
              }
            }}
            data={dokter}
          />
        </Grid>
        <Grid item sm={4}>
          <InputOptionMaster
            name="dpjp_layanan_kode"
            label="DPJP LAYANAN"
            id="dpjp_layanan_kode"
            withSearch={true}
            needParse={false}
            value={formData.dpjp_layanan_kode}
            labelValue={formData.dpjp_layanan_name}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  dpjp_layanan_kode: null,
                  dpjp_layanan_name: "Pilih DPJP Layanan",
                })
              } else {
                setFormData({
                  ...formData,
                  dpjp_layanan_kode: e?.value,
                  dpjp_layanan_name: e?.label,
                })
              }
            }}
            data={rows}
          />
        </Grid>
        <Grid item sm={4}>
          <InputAsyncOptionMaster
            label="POLIKLINIK"
            name="nama_poliklinik"
            id="nama_poliklinik"
            needParse={false}
            withSearch={true}
            data={[]}
            error
            message="Masukkan minimal 3 karakter"
            loadOptions={preLoadDataPoliklinik}
            defaultData={formData.kode_poliklinik}
            value={formData.kode_poliklinik}
            labelValue={formData.nama_poliklinik}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  kode_poliklinik: "",
                  nama_poliklinik: "",
                })
              } else {
                setFormData({
                  ...formData,
                  kode_poliklinik: e.value,
                  nama_poliklinik: e.label,
                })
              }
            }}
          />
        </Grid>

        <Grid item sm={4}>
          <InputOptionMaster
            name="tujuan_kunjungan"
            label="TUJUAN KUNJUNGAN"
            id="tujuan_kunjungan"
            value={formData.tujuan_kunjungan}
            onChange={handleChange("tujuan_kunjungan")}
            data={PILIH_TUJUAN_KUNJUNGAN}
            placeholder=""
          />
        </Grid>

        {formData.tujuan_kunjungan !== TUJUAN_KUNJUNGAN_NORMAL && (
          <Grid item sm={8}>
            <InputOptionMaster
              name="assesment_pel"
              label="ASSESMENT PELAYANAN"
              id="assesment_pel"
              value={formData.assesment_pel}
              onChange={handleChange("assesment_pel")}
              data={PILIH_ASSESMENT_PELAYANAN_SELAIN_NORMAL}
              placeholder=""
            />
          </Grid>
        )}

        {formData.tujuan_kunjungan === TUJUAN_KUNJUNGAN_PROSEDUR && (
          <>
            <PilihFlagProcedure
              handleChange={handleChange}
              formData={formData}
            />
            <PilihKodePenunjang
              handleChange={handleChange}
              formData={formData}
            />
          </>
        )}

        <Grid item sm={12}>
          <Grid container spacing={1}>
            <Grid item sm={4}>
              <InputTextMaster
                name="hak_kelas"
                label="HAK KELAS"
                id="hak_kelas"
                readOnly={true}
                disabled={true}
                value={formData.hak_kelas}
                onChange={handleChange("hak_kelas")}
                placeholder=""
              />
            </Grid>

            <Grid item sm={4}>
              <InputOptionMaster
                name="kls_rawat_naik"
                label="KELAS RAWAT NAIK"
                id="kls_rawat_naik"
                value={formData.kls_rawat_naik}
                withSearch={true}
                labelValue={formData.kls_rawat_naik_name}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      kls_rawat_naik: null,
                      kls_rawat_naik_name: "Pilih Kelas Rawat",
                    })
                  } else {
                    setFormData({
                      ...formData,
                      kls_rawat_naik: e.value,
                      kls_rawat_naik_name: e.label,
                    })
                  }
                }}
                data={kelasRawat}
              />
            </Grid>

            <Grid item xs={4}>
              <div
                style={{
                  display: "flex",
                }}
              >
                <InputTextMaster
                  name="nokontrol"
                  label="NO SPRI"
                  id="nokontrol"
                  placeholder="No SPRI"
                  value={formData.nokontrol}
                  onChange={handleChange("nokontrol")}
                />

                <MasterButton
                  type={"button"}
                  color="lightgreen"
                  name=""
                  size="sm"
                  withIcon={true}
                  onClick={handleClickNoKontrol}
                  style={{
                    marginTop: "1.5rem",
                    width: "32px",
                    height: "32px",
                  }}
                  icon={
                    <SelectIcon
                      width="16px"
                      height="16px"
                      style={{
                        marginLeft: "-0.5rem",
                      }}
                    />
                  }
                />
              </div>
            </Grid>
          </Grid>
        </Grid>

        {!isNull(formData.kls_rawat_naik) && (
          <Grid item sm={12}>
            <InputOptionMaster
              name="pembiayaan"
              label="PEMBIAYAAN"
              id="pembiayaan"
              value={formData.pembiayaan}
              onChange={handleChange("pembiayaan")}
              data={pembiayaanDanPenanggungJawab}
              placeholder=""
            />
          </Grid>
        )}
      </>
    )
  } else {
    return <></>
  }
}
